// extracted by mini-css-extract-plugin
export default {"Container":"FilterTitle_Container__zpeaC"};